<template>
    <div class="wrapper food grey">
      <div class="mycontent">
        <div class="food__intro">
            <h2>{{  Content.title }}</h2>
            <p>{{  Content.intro }}</p>
        </div>
        <div class="food__list">
            <a v-for="(item, i) in Content.list"
                :key="`grid_${i}`" :href="`${ item.link }`" target="_blank">
                <img :src="`${item.img}`" alt="">
                <div>
                    <p>{{ item.title }}</p>
                </div>
            </a>

            <p class="disclaimer">{{ Content.disclaimer}}</p>
        </div>

        <button id="see-more" @click="loadMore()">See more</button>

        <div class="food__word" v-if="showWords">
            <h2>{{  ContentWord.title }}</h2>

            <div class="food__word__top">
                <VueSlickCarousel class="slider-nav" v-bind="settings" ref="sliderNav">
                    <div class="slide" data-aos="zoom-in" data-aos-delay="0" data-aos-duration="500" data-aos-offset="0" v-for="(item, i) in ContentWord.words" :key="`grid_${i}`">
                        <div class="intro">
                            <img :src="`${item.img}`" alt="Cristina Aguilera">
                            <p class="title">{{ item.name }}</p>
                            <p class="role">{{  item.role }}</p>
                        </div>

                        <div class="content">
                            <p>{{  item.quote }}</p>
                        </div>
                    </div>
                </VueSlickCarousel>
            </div>
        </div>
      </div>
    </div>   
</template>

<script>
let lang = process.env.VUE_APP_LOCALITY;
import Content from "../data/content";
import VueSlickCarousel from "vue-slick-carousel";
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';


export default {
    name: 'About',
    components: {
        VueSlickCarousel
    },
    methods: {
        async loadMore() {
            let loadmore = document.getElementById('see-more');
            loadmore.style.display = 'none';

            let list = document.getElementsByClassName('food__list');
            list[0].style.maxHeight = list[0].scrollHeight + 'px';
        }
    },
    data: function() {
        return {
            Content: Content[lang].food,
            ContentWord: Content[lang].word,
            showWords: lang == 'en_gb' || lang == 'ie_ie' || lang == 'dk_en' || lang == 'dk_dk' ? true : false,
            settings: {
                arrows: true,
                dots: true,
                clickable: true,
                slidesToShow: 3,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            'slidesToShow': 1,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 1023,
                        settings: {
                            'slidesToShow': 2,
                            arrows: false,
                        }
                    }
                ],
                asNavFor: this.$refs.sliderFor,

            },
        }
    }
}
</script>

<style lang="scss">
.food {
    padding: 80px 0 87px;

    h2 {
        font-size: 32px;
        line-height: 130%;
        max-widtH: 815px;
        margin: 0 auto 22px;
        font-family: 'jet-extrabold';

        @media only screen and (max-width :1023px){
            font-size: 20px;
            max-widtH: 640px;
            line-height: 130%;
        }

        @media only screen and (max-width: 768px) {
            max-widtH: 320px;
        }
    }

    p {
        font-size: 16px;
        line-height: 150%;
        max-width: 600px;
        margin: 0 auto 50px;
        text-align: center;

        @media only screen and (max-width :1023px){
            font-size: 14px;
            line-height: 150%;
            max-widtH: 536px;
        }

        @media only screen and (max-width: 768px) {
            max-widtH: 268px;
        }
    }

    &__list {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 67px;
        border-bottom: 1px solid #DBD9D7;
        transition: all 0.25s ease-in-out;

        @media only screen and (max-width: 1023px) {
            width: calc(100% - 70px);
            margin: 0 auto;
            justify-content: space-between;
        }

        @media only screen and (max-width: 768px) {
            width: calc(100% - 70px);
            margin: 0 auto 30px;
            max-width: 330px;
            max-height: 900px;
            overflow: hidden;
        }
    }

    #see-more {
        margin: 0 auto;
        position: relative;
        display: none;

        @media only screen and (max-width: 768px) {
            display: block;
        }

        &:before {
            content: '';
            display: block;
            background: url('https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/arrow.svg');
            background-repeat: no-repeat;
            background-size: cover;
            height: 17px;
            width: 17px;
            transform: rotate(90deg) translateY(-50%);
            position: absolute;
            top: 20%;
            left: 10px;
        }
    }

    &__list a {
        width: calc( 25% - 15px);
        margin-right: 15px;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
        text-decoration: none;

        @media only screen and (max-width :1023px){
            width: calc(50% - 15px);
            margin-right: 0;
            margin-bottom: 30px;
        }

        @media only screen and (max-width :768px){
            width: 100%;
            margin-right: 0;
            margin-bottom: 10px;
        }

        &:nth-of-type(4n) {
            margin-right: 0;
        }

        img {
            width: 50%;
            border-radius: 20px 0 0px 20px;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }

        p {
            font-size: 18px;
            color: #242E30;
            font-family: 'jet-bold';
            text-align: left;
            white-space: break-spaces;
            word-wrap: break-word;
        }

        div {
            background: white;
            border-radius: 0 20px 20px 0;
            padding: 17px;
            width: 50%;
            position: relative;

            &:after {
                content: '';
                display: block;
                background: #EFEDEA url('https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/link.svg');
                background-position: center;
                position: absolute;
                bottom: 17px;
                right: 17px;
                background-size: 15px 15px;
                background-repeat: no-repeat;
                height: 30px;
                width: 30px;
                border-radius: 50%;
            }
        }
    }

    .disclaimer {
        color: #242E30;
        font-size: 12px;
        line-height: 18px;
        margin: 25px auto 0;
        max-width: 100%;
        widtH: 100%;
    }

    &__word {
        padding-top: 70px;

        @media only screen and (max-width :1023px){
            padding-top: 40px;
        }

        &__top {

            @media only screen and (max-width :1023px){
                margin: 0 15px;
            }

            .slick-slide {
                @media only screen and (max-width :1023px){
                    // width: calc(100vw) !important;
                }
            }
             .slide {
                text-align: left;

                div.intro {
                    width: calc(100% - 15px);
                    background: white;
                    border-radius: 20px;
                    padding: 24px;
                    margin-bottom: 30px;
                    position: relative;

                    @media only screen and (max-width :1023px){
                        width: calc(100% - 15px);
                    }

                    @media only screen and (max-width :768px){
                        width: calc(100% - 150px);
                        min-height: 315px;
                    }

                    img {
                        border-radius: 20px;
                    }
                }

                div.content {
                    width: calc(300% - 15px);
                    background: white;
                    border-radius: 20px;
                    padding: 45px 0;
                    opacity: 0;
                    transition: all 0.25s ease-in-out;

                    @media only screen and (max-width :1023px){
                        width: calc(200% - 15px);
                    }

                    @media only screen and (max-width :768px){
                        width: 100%;
                    }

                    p {
                        margin-bottom: 0;
                    }
                }

                img {
                    width: 100%;
                }

                .title {
                    line-height: 24px;
                    font-size: 22px;
                    font-family: 'jet-extrabold';
                    margin: 20px auto 8px 0;
                    text-align: left;
                }

                .role {
                    font-size: 14px;
                    line-height: 18px;
                    margin: 0;
                    text-align: left;
                }
             }

             .slick-current {
                .intro {
                    &:after {
                        content: '';
                        display: block;
                        width: 0;
                        position: absolute;
                        bottom: -14px;
                        left: 50%;
                        transform: translateX(-50%);
                        height: 0;
                        border-left: 15px solid transparent;
                        border-right: 15px solid transparent;
                        border-top: 15px solid white;
                        font-size: 0;
                        line-height: 0;
                        float: left;
                    }
                }
                .content {
                    opacity: 1 !important;
                }

                + .slick-slide {
                    @media only screen and (max-width :768px){
                        margin-left: -125px;
                    }
                }
            }


             .slider-nav {
                margin-bottom: 25px;
             }

             .slide-text {
                background: white;
                padding: 45px 0;
                border-radius: 20px;

                p {
                    margin-bottom: 0;
                }
             }

             .slick-dots {
                bottom: -50px;

                button {
                    &:before {
                        content:'';
                        background: transparent;
                        border-radius: 50%;
                        height: 8px;
                        width: 8px;
                        border: 1px solid #262626;
                        transition: all 0.25s ease-in-out;
                    }

                    &:hover {
                        &:before {
                            background: #262626;
                        }
                    }
                }

                li.slick-active {
                    button:before {
                        background: #262626;
                    }
                }
             }

             .slick-arrow {
                top: 200px;

                &:before {
                    content: '';
                    background: url('https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/arrow.svg');
                    display: block;
                    background-size: 30px;
                    background-position: right;
                    height: 30px;
                    width: 30px;
                }

                &.slick-next {
                    right: -197px;
                }

                &.slick-prev {
                    left: -45px;

                    &:before {
                        transform: rotate(-180deg);
                    }
                }
             }
        }
    }
}
</style>